import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'sub-query-builder',
    templateUrl: './sub-query-builder.component.html',
    styleUrls: ['./sub-query.component.css']
})
export class SubQueryBuilderComponent implements OnInit {
    @Input() ruleset: any;
    @Input() attributeTypeList: any;
    @Input() functionList: any;
    @Input() operatorList: any;
    @Input() deleteRuleSet: boolean;
    @Input() parent: any;
    @Input() index: number;
    attributeName: any;
    addRule(data) {
        const newRule = {
            'field': null,
            'type': null,
            'function': null,
            'operator': null,
            'value': null
        };
        data.rules.push(newRule);
    }
    addRuleSet(data) {

        const newRuleSet = {
            'condition': 'and',
            'rules': [
                {
                    'field': null,
                    'type': null,
                    'function': null,
                    'operator': null,
                    'value': null
                }]
        };
        data.rules.push(newRuleSet);
    }
    removeRule(data, i) {
        data.splice(i, 1);
    }
    ngOnInit(): void {
    }

    removeRuleSet(parent) {
        parent.rules.splice(this.index, 1);
    }


    bindNameAndTypeOfAttributes(rule, index) {
        // rule['field'] = this.attributeName;
        for (const object1 of this.attributeTypeList) {
            if (object1['name'] === rule['field']) {
                rule['type'] = object1['type'];
            }
        }
        // this.attributeName = null;
    }
}
